<button class="btn" (click)="showContextOverlay(contextModal)" placement="bottom" ngbTooltip="Click to change your Company, Account, or Property" triggers="hover" [openDelay]="750" [closeDelay]="250">
  <span *ngIf="company$ | async">
    <small>
      {{ (company$ | async)?.name }}
    </small>
    <span>{{ (property$ | async)?.name }}</span>
  </span>
  <fa-icon [icon]="icons.openContext"></fa-icon>
</button>
<ng-template #contextModal let-modal>
  <app-context-selector (cancelled)="closeContextOverlay()" (contextUpdated)="closeContextOverlay()" [changingContext]="true"></app-context-selector>
</ng-template>
